const Upload = () => import("~/components/Views/Prova/UploadGabarito");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Gerenciamento", link: "" }
];

export const uploadGabarito = [
  {
    path: "gerenciamento/upload-gabarito",
    component: Upload,
    name: "Upload de Gabarito",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/gerenciamento/uploadGabarito.js